import { render } from "./channelFinancialDetail.vue?vue&type=template&id=11cd5ffc&scoped=true"
import script from "./channelFinancialDetail.vue?vue&type=script&lang=js"
export * from "./channelFinancialDetail.vue?vue&type=script&lang=js"

import "./channelFinancialDetail.vue?vue&type=style&index=0&id=11cd5ffc&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11cd5ffc"]])

export default __exports__